import instance from "../utils/axios.wrapper";
import { convertObjToQueryParams } from "../utils/basic.utils";

// Transactions APi
export const userGetTransactions = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/transactions${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetTransactionSingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/transactions/${id}`);
  const result = await data;
  return result;
};

export const userGetTransactionDispute = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(`/api/v1/transaction-disputes`, body);
  const result = await data;
  return result;
};

// Books API
export const userGetBooks = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/books${convertObjToQueryParams({
      ...body,
      publishStatusId: 1,
    })}`
  );
  const result = await data;
  return result;
};

export const userGetBookSingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/books/${id}`);
  const result = await data;
  return result;
};

export const userStreamBookAudio = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`/api/v1/user/book-audios/${id}/stream`);
  const result = await data;
  return result;
};

// Book Categories API
export const userGetBookCategories = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/book-categories${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetBookCategorySingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/book-categories/${id}`);
  const result = await data;
  return result;
};

// Book Groups
export const userGetBookGroups = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/book-groups${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetBookGroup = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/book-groups/${id}`);
  const result = await data;
  return result;
};

// Book Tags API
export const userGetBookTags = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/book-tags/summary${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetBookTagSingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/book-tags/${id}`);
  const result = await data;
  return result;
};

// Special for Home Page

export const userGetBooksByTag = async (tag: string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/books?tag=${tag}&publishStatusId=1`
  );
  return data;
};

export const userGetBooksByTags = async (tags: string[]) => {
  const axios = await instance(null, null, true);

  const queryString = tags
    .map((tag) => `tags[]=${encodeURIComponent(tag)}`)
    .join("&");

  const { data } = await axios.get(
    `api/v1/user/books?${queryString}&publishStatusId=1`
  );
  return data;
};

export const userGetBooksByCategory = async (category: string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/books?categoryId=${category}&publishStatusId=1`
  );
  return data;
};

export const userGetBooksByCategories = async (categories: string[]) => {
  const axios = await instance(null, null, true);

  const queryString = categories
    .map((cat) => `categoryIds[]=${encodeURIComponent(cat)}`)
    .join("&");

  const { data } = await axios.get(
    `api/v1/user/books?${queryString}&publishStatusId=1`
  );
  return data;
};

export const userGetBookNewReleases = async () => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/books?isNewRelease=true&publishStatusId=1`
  );
  return data;
};

export const userGetRecommendedBooks = async () => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/books/recommended`);
  return data;
};

export const userGetAllBooks = async () => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/books`);
  return data;
};

// Get Subscription Plan

export const userGetSubcriptionPricing = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/subscription-pricings${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetSubcriptionPricingSingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/subscription-pricings/${id}`);
  const result = await data;
  return result;
};

export const userGetSubcriptionPayment = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(`api/v1/user/subscriptions`, body);
  const result = await data;
  return result;
};

export const userGetBookPayment = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(`api/v1/user/book-purchase-payments`, body);
  const result = await data;
  return result;
};

export const userGetSubcriptionPaymentToken = async (token: string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/subscriptions/details/${token}`
  );
  const result = await data;
  return result;
};

export const userCompletePayPalSubscription = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    `api/v1/user/subscriptions/complete-paypal`,
    body
  );
  const result = await data;
  return result;
};

export const userCompleteStripe = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    `api/v1/user/subscriptions/complete-stripe`,
    body
  );
  const result = await data;
  return result;
};

export const userGetBookPaymentToken = async (token: string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/book-purchase-payments/details/${token}`
  );
  const result = await data;
  return result;
};

export const userGetBookPaypalCreateOrder = async (body: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    `api/v1/user/book-purchase-payments/paypal/orders`,
    body
  );
  const result = await data;
  return result;
};

export const userGetBookPaypalCapture = async (id: string | number) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    `api/v1/user/book-purchase-payments/paypal/orders/${id}/capture`
  );
  const result = await data;
  return result;
};

export const userCompleteBookPaymentStripe = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(
    `api/v1/user/book-purchase-payments/complete-stripe`,
    body
  );
  const result = await data;
  return result;
};

export const userCancelSubcriptionPayment = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.post(`api/v1/user/subscriptions/cancel`, body);
  const result = await data;
  return result;
};

// Invoice

export const userGetInvoice = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/invoices${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetInvoiceSingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/invoices/${id}`);
  const result = await data;
  return result;
};

// Get Shorts
export const userGetShorts = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(
    `api/v1/user/shorts${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

export const userGetShortsSingle = async (id: number | string) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.get(`api/v1/user/shorts/${id}`);
  const result = await data;
  return result;
};

// delete account

export const userDeleteAccount = async (body?: any) => {
  const axios = await instance(null, null, true);
  const { data } = await axios.delete(
    `api/v1/user/auth/delete-account${convertObjToQueryParams(body)}`
  );
  const result = await data;
  return result;
};

// Temporarly APi
export const adminGetShortTest = async (query?: any) => {
  const axios = await instance(
    "",
    "https://next-js-practice-keyway-app.vercel.app/",
    false
  );
  const { data } = await axios.get(
    `/api/shorts${convertObjToQueryParams(query)}` // Changed 'short' to 'shorts'
  );
  return data;
};

export const adminGetShortSingleTest = async (id?: number | string) => {
  const axios = await instance(
    "",
    "https://next-js-practice-keyway-app.vercel.app/",
    false
  );
  const { data } = await axios.get(`/api/shorts/${id}`); // Changed 'short' to 'shorts'
  return data;
};
